module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABC0lEQVR4Ae3XIQjCQBiGYYPRaDAaF+wY7XYMdoxGg2HBaDQYDUaj0WAwGOysJzsGw8J84/HDwR0f58bYB28870EWtl7rVlVVRkta0LhOSJ/O5K6kI/XrAOXk2yHFhVNaU062PZUO4E4v80/tPGdXNIjFHCl0F+ccqKB9aBOKGVPMTs7ZG8VsEgLaUMxKOtGFYreWHtYEy5sI6kBPejcF9KABZRalgQSM87uzOkEWM6IiPUjDpAEJGBn0pkLGCCCLyewlIkYCzexlOkYDFTSyl4oYCeRDKRgB5EGJGB1kUSJGB1mUiNFAHhR170OtA+kv+Ys/Yb40DP1mv1LqHWK/Xie0pTxB8163bon2A9SkcWN7V+X6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/navigation/site_monitoring.png
// module id = /TH0
// module chunks = 0